import React from 'react';
import { Button } from './ui/Button';
import { motion } from 'framer-motion';
import { ArrowRight, CheckCircle2 } from 'lucide-react';
export function Hero() {
  const scrollToOffer = () => {
    document.getElementById('offer')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative pt-12 pb-16 md:pt-20 md:pb-24 px-4 sm:px-6 lg:px-8 bg-[#FDFBF7] overflow-hidden" data-id="element-21">
      <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-22">
        {/* Text Content - First */}
        <motion.div initial={{
        opacity: 0,
        x: -20
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-23">
          <div className="inline-flex items-center px-3 py-1 rounded-full bg-[#E8F2F1] text-[#1A5F5A] text-sm font-semibold mb-6" data-id="element-24">
            <span className="mr-2" data-id="element-25">✨</span> Especial para mujeres 65+
          </div>

          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-[#2D2D2D] leading-tight mb-6 font-serif" data-id="element-26">
            Camina sin miedo en <span className="text-[#C96B4B]" data-id="element-27">14 días</span>
          </h1>

          <p className="text-xl text-[#4A4A4A] mb-8 leading-relaxed max-w-lg" data-id="element-28">
            El método 3N para rodillas 65+: fuerza sin castigo, en casa, con
            silla y pared. Recupera tu libertad de movimiento.
          </p>

          {/* Image - Before Button on Mobile */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="relative mb-8 lg:hidden" data-id="element-29">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl border-4 border-white" data-id="element-30">
              <img src="https://cdn.magicpatterns.com/uploads/hG53EhvcYRZmMHqcyFHyCx/gemini-generated-image-1769840339697.png" alt="Rodillas Fuertes 65+ Programa en Tablet" className="w-full h-auto object-cover" data-id="element-31" />
            </div>
          </motion.div>

          <div className="flex flex-col sm:flex-row gap-4 mb-8" data-id="element-32">
            <Button size="lg" onClick={scrollToOffer} className="text-lg px-8 shadow-xl shadow-[#C96B4B]/20" data-id="element-33">
              Quiero caminar con confianza
              <ArrowRight className="ml-2 h-5 w-5" data-id="element-34" />
            </Button>
          </div>

          <div className="flex flex-col gap-3 text-sm text-[#4A4A4A]" data-id="element-35">
            <div className="flex items-center" data-id="element-36">
              <CheckCircle2 className="h-5 w-5 text-[#1A5F5A] mr-2" data-id="element-37" />
              <span data-id="element-38">Sin saltos ni impacto</span>
            </div>
            <div className="flex items-center" data-id="element-39">
              <CheckCircle2 className="h-5 w-5 text-[#1A5F5A] mr-2" data-id="element-40" />
              <span data-id="element-41">100% seguro para hacer en casa</span>
            </div>
          </div>
        </motion.div>

        {/* Image Content - Desktop Only */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="relative hidden lg:block" data-id="element-42">
          <div className="relative rounded-2xl overflow-hidden shadow-2xl border-4 border-white" data-id="element-43">
            <img src="https://cdn.magicpatterns.com/uploads/hG53EhvcYRZmMHqcyFHyCx/gemini-generated-image-1769840339697.png" alt="Rodillas Fuertes 65+ Programa en Tablet" className="w-full h-auto object-cover" data-id="element-44" />

            {/* Floating Badge */}
            <div className="absolute bottom-6 left-6 bg-white/95 backdrop-blur-sm p-4 rounded-xl shadow-lg max-w-xs" data-id="element-45">
              <p className="text-[#1A5F5A] font-bold text-lg mb-1" data-id="element-46">Método 3N</p>
              <p className="text-sm text-gray-600" data-id="element-47">
                Nutrir → Normalizar → Navegar
              </p>
            </div>
          </div>

          {/* Decorative elements */}
          <div className="absolute -z-10 top-10 -right-10 w-64 h-64 bg-[#C96B4B]/10 rounded-full blur-3xl" data-id="element-48"></div>
          <div className="absolute -z-10 -bottom-10 -left-10 w-64 h-64 bg-[#1A5F5A]/10 rounded-full blur-3xl" data-id="element-49"></div>
        </motion.div>
      </div>
    </section>;
}